export function areArrayEqual<T>(a: Array<T>, b: Array<T>, itemCompareCallback: (a: T, b: T) => boolean = undefined) {
    if (a == undefined && b != undefined) return false;
    if (a != undefined && b == undefined) return false;
    if (a == undefined && b == undefined) return true;
    if (a.length != b.length) return false;
    for (let index = 0; index < a.length; index++) {
        if (itemCompareCallback) {
            if (!itemCompareCallback(a[index], b[index])) return false;
        }
        else if (a[index] !== b[index]) {
            return false;
        }
    }
    return true;


}